<!--
 * @Author: quwandong
 * @Date: 2022-05-17 09:21:57
 * @LastEditors: quwandong
 * @LastEditTime: 2022-08-11 10:28:42
 * @FilePath: \motion\src\views\Cooperative\LoanOrder\List.vue
 * @Description: 北斗订单列表
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="card-box">
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="top-card">
            <div class="content-box">
              <div class="text-gray">放款数量</div>
              <div class="text-bold">{{ loanStatistics.applyCount || 0 }}</div>
            </div>
            <i class="icon first"></i>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="top-card">
            <div class="content-box">
              <div class="text-gray">放款总额</div>
              <div class="text-bold">
                ￥{{ loanStatistics.applyAmount || 0 }}
              </div>
            </div>
            <i class="icon second"></i>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="top-card">
            <div class="content-box">
              <div class="text-gray">已贴息数量</div>
              <div class="text-bold">
                {{ loanStatistics.subsisdyCount || 0 }}
              </div>
            </div>
            <i class="icon third"></i>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="top-card">
            <div class="content-box">
              <div class="text-gray">贴息总额</div>
              <div class="text-bold">
                ￥{{ loanStatistics.subsisdyAmount || 0 }}
              </div>
            </div>
            <i class="icon fourth"></i>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="main">
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item>
            <el-date-picker
              v-model="filterForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 300px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filterForm.applyNum"
              placeholder="订单编号"
              prop="applyNum"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="filterForm.applyState"
              prop="applyState"
              placeholder="订单状态"
              style="width: 120px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="(item, index) in uniqeGlobalDict$$.loanOrderStatus"
                :key="index"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filterForm.nameOrPhone"
              placeholder="贷款客户"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-select
              v-model="filterForm.subsidyState"
              prop="subsidyState"
              placeholder="贴息状态"
              style="width: 140px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="(item, index) in uniqeGlobalDict$$.loanSubsidyStatus"
                :key="index"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
            >
              清空
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="tableData"
        v-loading="pagination.loading"
        style="width: 100%; margin-top: 10px"
      >
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="applyTime"
          label="订单日期"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="applyNum"
          label="订单编号"
          width="300"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="订单状态"
          width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="realName"
          label="贷款客户"
          width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="pordInfo"
          label="贷款机具"
          min-width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="subsidyInterestName"
          label="贴息状态"
          width="120"
          align="center"
        >
        </el-table-column>

        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="goDetail(row.applyId)"
            >
              订单查看
            </el-button>
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="goDiscountDetail(row)"
              v-if="row.subsidyInterestStatus !== 'NS9901'"
            >
              贴息查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.size"
        :total="pagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
import { formatDate } from '@/utils/formatDate'
export default {
  name: 'LoanOrderList',
  $dictKeyList: [
    {
      key: 'loanOrderStatus',
      name: '贷款订单状态',
    },
    // {
    //   key: 'loanSubsidyStatus',
    //   name: '贷款订单贴息状态',
    // },
  ],
  data() {
    return {
      filterForm: {
        dateRange: [],
        applyNum: '', // 订单编号
        applyState: '', // 订单状态
        nameOrPhone: '', // 贷款客户
        subsidyState: '', // 贴息状态
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
        loading: false,
      },
      tableData: [],

      loanStatistics: {}, // 放款统计
    }
  },
  async mounted() {
    this.getLoanStatistics()
    this.getBdOrderList()
  },
  methods: {
    /**
     * @description: 获取统计详情
     * @Author: quwandong
     * @Date: 2022-05-17 18:56:34
     */
    async getLoanStatistics() {
      try {
        const res = await this.$http.loanOrder.getLoanStatistics({
          masterId: this.$route.query.$businessId,
        })
        this.loanStatistics = res.data
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description: 获取贷款订单列表
     * @Author: quwandong
     * @Date: 2022-05-17 14:08:47
     */
    async getBdOrderList() {
      try {
        this.pagination.loading = true
        const [starTime, endTime] = this.filterForm.dateRange
        const { applyNum, applyState, nameOrPhone, subsidyState } =
          this.filterForm

        let params = {
          currentPage: this.pagination.page,
          pageSize: this.pagination.size,
          masterId: this.$route.query.$businessId,
        }
        starTime &&
          (params.starTime = formatDate(new Date(starTime), 'yyyy-MM-dd'))
        endTime &&
          (params.endTime = formatDate(new Date(endTime), 'yyyy-MM-dd'))
        applyState && (params.applyState = applyState)
        applyNum && (params.applyNum = applyNum)
        nameOrPhone && (params.nameOrPhone = nameOrPhone)
        subsidyState && (params.subsidyState = subsidyState)

        const res = await this.$http.loanOrder.getOrderlist(params)
        this.tableData = res.data.content

        if (this.pagination.page == 1) {
          this.pagination.total = res.data.recordTotal
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.pagination.loading = false
      }
    },
    /**
     * @description: 条件查询
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:07
     */
    handleFilter() {
      this.pagination.page = 1
      this.getBdOrderList()
    },
    /**
     * @description: 重置查询表单
     * @param formName
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:27
     */
    handleReset() {
      this.filterForm.dateRange = []
      this.filterForm.applyNum = ''
      this.filterForm.applyState = ''
      this.filterForm.subsidyState = ''
      this.filterForm.nameOrPhone = ''
      this.$nextTick(() => {
        this.handleFilter()
      })
    },
    /**
     * @description: 点击分页
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:53
     */
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getBdOrderList()
    },
    /**
     * @description: 跳转详情页面
     * @param id
     * @Author: quwandong
     * @Date: 2022-05-17 14:24:25
     */
    goDetail(id) {
      this.$router.push({
        path: '/cooperative/loanOrder/detail',
        query: { id },
      })
    },
    /**
     * @description: 贴息查看
     * @param id
     * @Author: quwandong
     * @Date: 2022-05-18 10:02:56
     */
    goDiscountDetail(row) {
      const id = row.applyId
      this.$router.push({
        path: '/cooperative/loanOrder/discountDetail',
        query: { id, applyNum: row.applyNum, applyTime: row.applyTime },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-box {
  padding: 10px 16px 0 16px;
  .top-card {
    height: 110px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 26px 25px;
    box-sizing: border-box;

    i.icon {
      width: 110px;
      height: 110px;
      background-size: 100% 100%;

      &.first {
        background: url('~assets/loanOrder/icon_fangkuanshuliang.png');
      }
      &.second {
        background: url('~assets/loanOrder/icon_fangkuanzonge.png');
      }
      &.third {
        background: url('~assets/loanOrder/icon_yitiexishuliang.png');
      }
      &.fourth {
        background: url('~assets/loanOrder/icon_tiexizonge.png');
      }
    }

    .text-bold {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #222222;
    }

    .text-gray {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #888888;
    }
  }
}
</style>
